import { render } from "./QHLSExamCenter.vue?vue&type=template&id=2c394488&scoped=true"
import script from "./QHLSExamCenter.vue?vue&type=script&lang=js"
export * from "./QHLSExamCenter.vue?vue&type=script&lang=js"

import "./QHLSExamCenter.vue?vue&type=style&index=0&id=2c394488&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c394488"]])

export default __exports__